<template>
    <b-row no-gutters>
        <b-col cols="1">
            <font-awesome-icon v-show="feature.editState" :icon="['fas', 'pen']" fixed-width />
        </b-col>
        <b-col cols="1" class='text-centered'> 
            <b-link @click="$emit('fly-to-feature', feature)">
                <font-awesome-icon :icon="['fas', getWaypointIcon()]" :color="linkedFeature.color" fixed-width />
            </b-link>
        </b-col>
        <b-col cols="10">
            <b-link
                v-b-modal.modal-1
                :class="{ 'font-weight-bold': feature.editState }"
                @click="$emit('feature-clicked', feature)"
                >
                {{ feature.name }}
            </b-link>
        </b-col>
    </b-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'WaypointFeature',
    props: {
        linkedFeature : Object
    },
    components: {
        FontAwesomeIcon
    },
    data: function () {
        return {
            feature : this.linkedFeature
        }
    },
    methods: {
        getWaypointIcon() {
            return this.linkedFeature.icon;
        }
    }
}
</script>


<style scoped>
</style>